import React, { useState } from "react";

export const ColorPicker = ({
  title,
  colors,
  setCompleted,
  onComplete,
  handleColorClick,
  showButton = true, // Added to toggle button visibility
}) => {
  const [activeColor, setActiveColor] = useState(false);

  return (
    <div className="conf-color-picker">
      <p className="marcellus-25-400">{title}</p>
      <div className="conf-color-picker__wrap">
        <div className="conf-color-picker__selected">
          {colors && colors.length ? (
            <>
              <img
                className="conf-color-picker__selected-image"
                src={activeColor ? activeColor.image.url : colors[0].image.url}
                alt={activeColor ? activeColor.image.alt : colors[0].image.alt}
              />
              <p className="poppins-18-400">
                {activeColor ? activeColor.name : colors[0].name}
              </p>
            </>
          ) : null}
        </div>
        <div className="conf-color-picker__items">
          {colors &&
            colors.length &&
            colors.map((color) => (
              <div
                key={color.name} // Added key for list rendering
                onClick={() => {
                  setActiveColor(color);
                  handleColorClick(color);
                }}
                className="conf-color-picker__items-item"
              >
                <img
                  className="conf-color-picker__selected-image"
                  src={color.image.url}
                  alt={color.image.alt}
                />
                <p className="poppins-12-400">{color.name}</p>
              </div>
            ))}
        </div>
      </div>
      {showButton && (
        <div className="conf-color-picker__btn-wrap">
          <button
            type="button"
            disabled={!activeColor}
            className={`conf-color-picker__btn btn green ${
              !activeColor ? "hidden" : ""
            }`}
            onClick={() => {
              setCompleted?.(true); // Optional chaining for optional prop
              onComplete?.(); // Optional chaining for optional prop
            }}
          >
            Nastavi
          </button>
        </div>
      )}
    </div>
  );
};
